export default class OfferLessonFilters {
    constructor($el) {
        this.$el = $el;
        this.$form = $el.querySelector('[data-offer-lesson-filter-form]');
        this.$location = $el.querySelector('[data-offer-lesson-filter="location"]');
        this.$day = $el.querySelector('[data-offer-lesson-filter="day"]');
        this.$coach = $el.querySelector('[data-offer-lesson-filter="coach"]');
        this.$empty = $el.querySelector('[data-offer-lesson-empty]');
        this.$count = $el.querySelector('[data-offer-lesson-count]');
        this.$reset = $el.querySelector('[data-offer-lesson-reset]');
        this.$groups = Array.from($el.querySelectorAll('[data-offer-lesson-group]'));
        this.$lessons = Array.from($el.querySelectorAll('[data-offer-lesson]'));

        if (!this.$form || !this.$lessons.length) {
            return;
        }

        this.$form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.apply();
        });

        [$el.querySelector('[data-offer-lesson-filter="location"]'), $el.querySelector('[data-offer-lesson-filter="day"]'), $el.querySelector('[data-offer-lesson-filter="coach"]')]
            .filter(Boolean)
            .forEach(($select) => {
                $select.addEventListener('change', () => this.apply());
            });

        this.apply(false);
    }

    apply(updateUrl = true) {
        const location = this.$location ? this.normalizeFilterValue(this.$location.value) : '';
        const day = this.$day ? this.normalizeFilterValue(this.$day.value) : '';
        const coach = this.$coach ? this.normalizeFilterValue(this.$coach.value) : '';
        let visibleCount = 0;

        this.$lessons.forEach(($lesson) => {
            const lessonLocation = this.normalizeFilterValue($lesson.dataset.location || '');
            const lessonDay = this.normalizeFilterValue($lesson.dataset.day || '');
            const lessonCoach = this.normalizeFilterValue($lesson.dataset.coach || '');
            const isVisible = (location === '' || lessonLocation === location)
                && (day === '' || lessonDay === day)
                && (coach === '' || this.splitCoachNames(lessonCoach).includes(coach));

            $lesson.hidden = !isVisible;
            if (isVisible) {
                visibleCount += 1;
            }
        });

        this.$groups.forEach(($group) => {
            $group.hidden = !$group.querySelector('[data-offer-lesson]:not([hidden])');
        });

        if (this.$empty) {
            this.$empty.hidden = visibleCount > 0;
        }

        if (this.$count) {
            this.$count.textContent = visibleCount === 1 ? '1 les' : `${visibleCount} lessen`;
        }

        if (this.$reset) {
            this.$reset.hidden = location === '' && day === '' && coach === '';
        }

        if (updateUrl) {
            this.updateUrl(location, day, coach);
        }
    }

    updateUrl(location, day, coach) {
        if (!window.history || !window.URLSearchParams) {
            return;
        }

        const url = new URL(window.location.href);
        this.setQueryVariable(url.searchParams, 'location', location);
        this.setQueryVariable(url.searchParams, 'day', day);
        this.setQueryVariable(url.searchParams, 'coach', coach);
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    }

    setQueryVariable(searchParams, key, value) {
        if (value === '') {
            searchParams.delete(key);
            return;
        }

        searchParams.set(key, value);
    }

    normalizeFilterValue(value) {
        return `${value}`.replace(/\s+/gu, ' ').trim();
    }

    splitCoachNames(value) {
        return value
            .split(/\s*(?:\||,|&|\ben\b)\s*/u)
            .map((coachName) => this.normalizeFilterValue(coachName))
            .filter(Boolean);
    }
}
